import type ReinforcementLearningRewardsEndpointRequest from '../schema/ReinforcementLearningRewardsEndpointRequest';

/**
 * Get a new ReinforcementLearningRewardsEndpoint Request
 */
export default function getReinforcementLearningRewardsEndpointRequest(
    scenarioName: string,
    timeStamp: string,
    correlationId: string,
    reward: string,
    extraFeatures: { [key: string]: string }
): ReinforcementLearningRewardsEndpointRequest {
    return {
        ScenarioName: scenarioName,
        TimeStamp: timeStamp,
        CorrelationId: correlationId,
        Reward: reward,
        ExtraFeatures: extraFeatures,
    } as ReinforcementLearningRewardsEndpointRequest;
}
